var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_40_49809)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 20.3453C16.2 17.4362 12.2546 16.8907 9.9455 17.8726C9.61823 18.018 9.90914 18.4907 10.2182 18.3453C11.691 17.7089 13.9637 17.7998 15.291 18.8726C13.3637 17.7998 10.6182 18.4544 9.49096 20.5453C9.32732 20.8544 9.80005 21.1453 9.96369 20.818C11.2182 18.5089 14.8364 18.1817 16.2182 20.5453C16.2728 20.6544 16.3819 20.6907 16.4728 20.6726C16.6364 20.7089 16.8364 20.5635 16.8 20.3453Z",
    fill: "#14110E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1636 20.3453C23.7636 17.4362 27.709 16.8907 30.0181 17.8726C30.3454 18.018 30.0545 18.4907 29.7454 18.3453C28.2726 17.7089 25.9999 17.7998 24.6726 18.8726C26.5999 17.7998 29.3454 18.4544 30.4726 20.5453C30.6363 20.8544 30.1636 21.1453 29.9999 20.818C28.7454 18.5089 25.1272 18.1817 23.7454 20.5453C23.6908 20.6544 23.5817 20.6907 23.4908 20.6726C23.309 20.7089 23.109 20.5635 23.1636 20.3453Z",
    fill: "#14110E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.8364 25.0871C14.8364 27.3053 13.0364 29.1235 10.8182 29.1235C8.60005 29.1235 6.80005 27.3235 6.80005 25.0871C6.80005 22.869 8.60005 21.0508 10.8182 21.0508C13.0364 21.0508 14.8364 22.8508 14.8364 25.0871Z",
    fill: "url(#paint1_radial_40_49809)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.3819 25.0871C33.3819 27.3053 31.5819 29.1235 29.3638 29.1235C27.1456 29.1235 25.3456 27.3235 25.3456 25.0871C25.3456 22.869 27.1456 21.0508 29.3638 21.0508C31.5819 21.0508 33.3819 22.8508 33.3819 25.0871Z",
    fill: "url(#paint2_radial_40_49809)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3091 13.3052C14.9091 12.2143 12.8546 12.0871 11.6728 13.578C11.4182 13.8871 11.8909 14.3052 12.1455 13.9962C13.1091 12.778 14.7637 12.8871 15.8909 13.778C16.2182 14.0143 16.6364 13.5598 16.3091 13.3052Z",
    fill: "#F5825E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7818 12.8326C15.3818 11.7417 13.3272 11.6144 12.1454 13.1053C11.8909 13.4144 12.3636 13.8326 12.6181 13.5235C13.5818 12.3053 15.2363 12.4144 16.3636 13.3053C16.6909 13.5417 17.109 13.0871 16.7818 12.8326Z",
    fill: "#14110E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2182 13.3052C26.8182 12.2143 24.7636 12.0871 23.5818 13.578C23.3273 13.8871 23.8 14.3052 24.0545 13.9962C25.0182 12.778 26.6727 12.8871 27.8 13.778C28.1273 14.0143 28.5454 13.5598 28.2182 13.3052Z",
    fill: "#F5825E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6908 12.8326C27.2908 11.7417 25.2363 11.6144 24.0545 13.1053C23.7999 13.4144 24.2726 13.8326 24.5272 13.5235C25.4908 12.3053 27.1454 12.4144 28.2726 13.3053C28.5999 13.5417 29.0181 13.0871 28.6908 12.8326Z",
    fill: "#14110E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63635 25.2363C9.63635 25.2363 18.4545 30.4727 31.0909 25.2363C31.0909 25.2363 20.9091 37.2727 9.63635 25.2363Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40_49809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.487641,
    stopColor: "#F6A78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_40_49809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8214 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#D93C0B",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#D93C0B",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#D93C0B",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#D93C0B",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_40_49809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3669 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#D93C0B",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#D93C0B",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#D93C0B",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#D93C0B",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodGood);
export default __webpack_public_path__ + "static/media/Mood_Good.00bf4ad164cb73748ee5b94c247fc5e8.svg";
export { ForwardRef as ReactComponent };